export default __webpack_public_path__ + "static/media/logorays.88eb8835.webp";